<footer class="my-5 py-5 text-muted text-center text-small">
  <p class="mb-1">&copy; {{year}} Matchedin</p>
</footer>
